import React from 'react'
import PropTypes from 'prop-types'
import humanizeDuration from 'humanize-duration'

import {
  FormattedMessage,
  useIntl,
} from 'react-intl'

import Locale from './locale'
import Styles from './styles.scss'


export default function StorageDisclosureRow({
  description,
  domains,
  identifier,
  maxAgeSeconds,
  optOut,
  specialPurposes,
  storageType,
}) {
  const { locale } = useIntl()

  const language = locale.replace(/-.*$/, '')


  const maxAge = formatMaxAge({
    language,
    maxAgeSeconds,
  })

  return (
    <tr>
      <td className={ Styles.td }>
        {
          renderDomainList(domains)
        }
      </td>
      <td className={ Styles.td }>
        { storageType }
      </td>
      <td className={ Styles.td }>
        { identifier }
      </td>
      <td className={ Styles.td }>
        { maxAge }
      </td>
      <td className={ Styles.td }>
        { description }
      </td>
      <td className={ Styles.td }>
        {
          ( optOut == null ) ? '' : String(optOut)
        }
      </td>
      <td className={ Styles.td }>
        { specialPurposes?.join(', ') }
      </td>
    </tr>
  )
}

StorageDisclosureRow.propTypes = {
  description: PropTypes.string,
  domains: PropTypes.arrayOf(PropTypes.string),
  identifier: PropTypes.string,
  maxAgeSeconds: PropTypes.number,
  optOut: PropTypes.bool,
  specialPurposes: PropTypes.arrayOf(PropTypes.string),
  storageType: PropTypes.string,
}

function renderDomainList(domains) {
  if ( !domains?.length ) {
    return null
  }

  const items = domains.map((domain) => (
    <li key={ domain }>
      { domain }
    </li>
  ))

  return (
    <ul className={ Styles.domains }>
      { items }
    </ul>
  )
}

function formatMaxAge({ language, maxAgeSeconds }) {
  // I'm not going to assume that 0 means "session," hence the
  // null/undefined check here.
  // eslint-disable-next-line eqeqeq
  if ( maxAgeSeconds == null ) {
    return (
      <FormattedMessage
        { ...Locale.session }
      />
    )
  }

  // I couldn't figure out a way to make react-intl do this, so after
  // much Googling, I came up with this library.
  return humanizeDuration(maxAgeSeconds, {
    language,
    largest: 2,
  })
}
